<script>

export default {
  name: 'GlobalDataMixin',
  data() {
    return {
      forbidden: false
    }
  },
  computed: {
    isAdmin() {
      if (this.globalData == null || this.globalData.currentOrganization == null) {
        return false;
      }
      return this.hasAdminAccessToOrganization(this.globalData.currentOrganization.uuid);
    },
    canManagePrograms() {
      // Coach and above. The server checks the exact organization (coaches are usually assigned to its teams).
      const roles = this.globalData && this.globalData.activeUser ? this.globalData.activeUser.roles : null;
      return roles != null && ['Owner', 'Admin', 'Coach'].some(role => roles[role] && roles[role].length > 0);
    },
    isOrganizationAdmin() {
      // Owner or Admin of the current organization. A SuperAdmin works there by impersonating one.
      const roles = this.globalData && this.globalData.activeUser ? this.globalData.activeUser.roles : null;
      const organization = this.globalData ? this.globalData.currentOrganization : null;
      return roles != null && organization != null
          && ['Owner', 'Admin'].some(role => roles[role] && roles[role].includes(organization.uuid));
    },
    canEditWorkouts() {
      // Owner, Admin or Coach of the current organization, or Coach of one of its teams: the same rule as the server
      const roles = this.globalData && this.globalData.activeUser ? this.globalData.activeUser.roles : null;
      const organization = this.globalData ? this.globalData.currentOrganization : null;
      if (roles == null || organization == null) {
        return false;
      }
      const has = (role, uuid) => roles[role] != null && roles[role].includes(uuid);
      return ['Owner', 'Admin', 'Coach'].some(role => has(role, organization.uuid))
          || (this.globalData.teams || []).some(team => has('Coach', team.group.uuid));
    },
    canViewRunners() {
      // The same roles the server allows. The server checks the exact team.
      const roles = this.globalData && this.globalData.activeUser ? this.globalData.activeUser.roles : null;
      return roles != null && ['Owner', 'Admin', 'Coach'].some(role => roles[role] && roles[role].length > 0);
    },
    isSuperAdmin() {
      return this.globalData ? this.globalData.activeUser.roles ?
          this.globalData.activeUser.roles['SuperAdmin'] != null : false : false;
    },
  },
  methods: {
    hasAdminAccessToOrganization(organizationUuid) {
      if (!this.globalData || !this.globalData.activeUser.roles) {
        return false;
      }
      if (this.globalData.activeUser.roles['SuperAdmin']) {
        return true;
      }
      if (this.globalData.activeUser.roles['Owner'] && this.globalData.activeUser.roles['Owner'].includes(organizationUuid)) {
        return true;
      }
      if (this.globalData.activeUser.roles['Admin'] && this.globalData.activeUser.roles['Admin'].includes(organizationUuid)) {
        return true;
      }

      return false;
    },
  }
}
</script>
